/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReading = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.895 4a1.947 1.947 0 1 0 0 3.895 1.947 1.947 0 0 0 0-3.895zM7.947 5.947a3.947 3.947 0 1 1 7.895 0 3.947 3.947 0 0 1-7.895 0zM4 9.674l8 2.286 8-2.286v10.08l-8 2.286-8-2.286zm7 4.08-5-1.428v5.92l5 1.428zm2 5.92 5-1.428v-5.92l-5 1.428z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReading as Reading };
